import { call } from "redux-saga/effects";

import masterChannelOperationSaga from "./masterChannelOperationSaga";

export default function* () {
  yield call(masterChannelOperationSaga, "previous");
}
